import React, { FunctionComponent } from "react";
import { DigitalShareAppType } from "../../../Enums/Enums";
import {
    ProgressBarBorder,
    ProgressBarCaption,
    ProgressScreenRightSection,
    ProgressBarProgress,
    ProgressBarTrack,
    ProgressScreenBackdrop,
    ProgressScreenContainer,
    ProgressBarContainer,
    ProgressBarPercentCaption,
    ProgressScreenTagline,
    ProgressScreenRightSectionContainer,
    ProgressScreenBackground,
    ProgressScreenContent,
} from "./DigitalShareCommonStyles";

export interface IProgressScreenProps {
  app: DigitalShareAppType;
  percentComplete: number;
  text: string;
  downloaded: boolean;
  onClose: () => void;
}

export const ProgressScreen: FunctionComponent<IProgressScreenProps> = (
    props: IProgressScreenProps
) => {
    const taglineUrl
    = props.app === DigitalShareAppType.RetailMatch
        ? "/Images/Digital Share/ProgressScreen/Logo_Tagline.svg"
        : "/Images/Digital Share/ProgressScreen/Mobilytics_Logo_Tagline.svg";

    return (
        <>
            <ProgressScreenBackdrop />
            <ProgressScreenContainer>
                <ProgressScreenBackground />
                <ProgressScreenContent>
                    <ProgressScreenTagline>
                        <img src={taglineUrl} />
                    </ProgressScreenTagline>
                    <ProgressScreenRightSectionContainer>
                        <ProgressScreenRightSection>
                            <ProgressBarContainer>
                                <ProgressBarPercentCaption>
                                    {props.percentComplete.toFixed(0)}%
                                </ProgressBarPercentCaption>
                                <ProgressBarBorder>
                                    <ProgressBarTrack>
                                        <ProgressBarProgress
                                            percentComplete={props.percentComplete}
                                        />
                                    </ProgressBarTrack>
                                    <img
                                        src="/Images/Digital Share/ProgressScreen/Checkmark_Active.svg"
                                        className="progress-screen-checkmark"
                                    />
                                </ProgressBarBorder>
                                <ProgressBarCaption>{props.text}</ProgressBarCaption>
                            </ProgressBarContainer>
                            {props.downloaded && (
                                <button onClick={props.onClose}>Close</button>
                            )}
                        </ProgressScreenRightSection>
                    </ProgressScreenRightSectionContainer>
                </ProgressScreenContent>
            </ProgressScreenContainer>
        </>
    );
};
